import { Component, OnInit, Input } from "@angular/core";
import { LoanApplication, ApplicationAccessSpecifier, Person } from "@app/applications/applications.model";
import { ApplicationService } from "@app/applications/application.service";
import { ImagePreviewDialogService } from "@app/utils/image-preview-dialog/image-preview-dialog.service";
import FileSaver from "file-saver";
import { MatSnackBar } from "@angular/material";
import { IgFileService } from "@ig-core/form/igFile.service";
import { FolderFilesComposite } from "../../loanInformation/loan-folder-files/loan-folder-files.model";
import { LoanDocumentDTO } from "../../loanInformation/loan-document/loan-document.model";
import { ConfirmationDialogService } from "@app/utils/confirmation-dialog/confirmation-dialog.service";
import { DataSourceService } from "@app/admin/admin-tool/data-source.service";
import { XDataRequestGroup } from "../../applicationDocument/xdata-service/xdata-registry.model";
import { FileUploadService } from "@app/utils/file-upload/file-upload.service";
import { SecureStorageService } from "@ig-core/authentication/secureStorage.service";
import { MAATRUM_REQUEST_TYPE } from "@app/constants/data.constants";
@Component({
  selector: "eng-legal-document",
  templateUrl: "./legal-document.template.html",
  styleUrls: ["../../application-details.styles.scss", "./legal-document.styles.scss"],
})
export class LegalDocumentComponent implements OnInit {
  @Input() application: LoanApplication;
  @Input() applicants: Person[];
  @Input() menuCode: string;

  allowAccess: Boolean;
  menuItemAllowAccess: boolean;
  showForm: boolean;
  isFormDisabled: boolean;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;

  legalDocuments: LoanDocumentDTO[] = [];
  selectedLegalDocument: LoanDocumentDTO;
  allLegalDocFilesInFolder: FolderFilesComposite;
  allLegalReportFilesInFolder: FolderFilesComposite;
  recentRequests: XDataRequestGroup[];
  legalReportRemarks: string;
  loginUser: any;
  isCopyFilesFromCollateral: boolean | null = null;
  showCreateLegalDocumentCard: boolean = false;
  newLegalDocumentName: string = '';

  constructor(
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private fileService: IgFileService,
    private imagePreviewDialogService: ImagePreviewDialogService,
    private confirmationDialogService: ConfirmationDialogService,
    private dataSourceService: DataSourceService,
    private fileUploadService: FileUploadService,
    private secureStorageService: SecureStorageService
  ) {
    this.allowAccess = this.applicationService.allowAccess;
  }
  ngOnInit() {
    this.loginUser = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails")
    this.getLegalDocument();
    this.getMenuItemAccess();
    this.getAnalyzerRequests();
  }

  getLegalDocument() {
    this.showForm = false;
    this.applicationService.getAllLegalDocuments(this.application.uid).subscribe((respose) => {
      this.legalDocuments = respose.body;
      if (this.legalDocuments.length > 0) {
        this.showForm = true;
        this.changeSelectedLegalDocument(this.legalDocuments[0], 0);
      }
    });
  }

  getAnalyzerRequests() {
    this.dataSourceService.findXdataRequest(this.application.uid, MAATRUM_REQUEST_TYPE).subscribe(response => {
      this.recentRequests = response.body;
    })
  }

  changeSelectedLegalDocument(legalDocument, index?: number) {
    this.clearAndResetData();
    this.selectedLegalDocument = legalDocument;
    this.legalReportRemarks = this.selectedLegalDocument.remarks;
    this.legalDocuments.forEach((element, i) => {
      this.legalDocuments[i].deleteBtnDisabled = true;
    });
    this.legalDocuments[index].deleteBtnDisabled = false;
    this.getLoanDocumentFolderFiles(legalDocument.folderUid);
    this.getLegalReportFolderFiles(legalDocument.legalReportFolderUid);
  }

  clearAndResetData() {
    this.isFormDisabled = true;
    this.showCreateLegalDocumentCard = false;
    this.newLegalDocumentName = '';
    this.isCopyFilesFromCollateral = null;
  }

  closeCards() {
    this.showCreateLegalDocumentCard = false;
  }

  getLoanDocumentFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allLegalDocFilesInFolder = response.body;
          this.allLegalDocFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      });
    } (error) => {
      this.allLegalDocFilesInFolder = {
        folderInfo: {},
        fileInfo: [],
      };
    }
  }

  getLegalReportFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allLegalReportFilesInFolder = response.body;
          this.allLegalReportFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      });
    } (error) => {
      this.allLegalReportFilesInFolder = {
        folderInfo: {},
        fileInfo: [],
      };
    }
  }

  toggleAddNew() {
    this.showCreateLegalDocumentCard = !this.showCreateLegalDocumentCard
  }

  generateLegalDoc() {
    if (this.isCopyFilesFromCollateral === null) {
      this._snackbar.open("Document type is required.", "Close", {
        duration: 5000,
      })
      return
    }

    if (!this.newLegalDocumentName || !this.newLegalDocumentName.trim()) {
      this._snackbar.open("Document name is required.", "Close", {
        duration: 5000,
      })
      return
    }

    this.applicationService.generateLegalDocument(this.application.uid, this.newLegalDocumentName.trim(), this.isCopyFilesFromCollateral).subscribe(response => {
      this.getLegalDocument();
    })
  }

  createLegalReport() {
    this.applicationService.createLegalReportFolder(this.application.uid, this.selectedLegalDocument.uid).subscribe(response => {
      this._snackbar.open("Legal report has been created successfully.", "Close", {
        duration: 5000,
      })
      const index = this.legalDocuments.findIndex(
        ele => ele.uid === this.selectedLegalDocument.uid
      );

      if (index !== -1) {
        this.legalDocuments[index] = response.body;
        this.changeSelectedLegalDocument(response.body, index);
      }
    })
  }

  verifyLegalReport() {
    if (!this.legalReportRemarks || !this.legalReportRemarks.trim()) {
      this._snackbar.open("Remarks is required.", "Close", {
        duration: 5000,
      })
      return
    }
    this.applicationService.verifyLegalReport(this.application.uid, this.selectedLegalDocument.uid, this.selectedLegalDocument.legalReportFolderUid, this.legalReportRemarks.trim()).subscribe(response => {
      this._snackbar.open("Legal report has been verified successfully.", "Close", {
        duration: 5000,
      })
      const index = this.legalDocuments.findIndex(
        ele => ele.uid === this.selectedLegalDocument.uid
      );

      if (index !== -1) {
        this.legalDocuments[index] = response.body;
        this.changeSelectedLegalDocument(response.body, index);
      }
    })
  }

  cancelForm() {
    if (this.legalDocuments.length > 0) {
      this.changeSelectedLegalDocument(this.legalDocuments[0], 0);
    } else {
      this.clearAndResetData();
    }
  }

  editLegalDocument() {
    if (this.selectedLegalDocument.status.toLocaleLowerCase() === 'verified') {
      this._snackbar.open("Loan document already verified. Edit not allowed.", "close", {
        duration: 5000
      })
      return;
    }

    if (this.allowAccess && this.menuItemAllowAccess && this.loginUser.authorities.includes('VERIFY-LEGAL-DOC')) {
      this.isFormDisabled = false;
    }
  }

  //this function will get either this menu item  is editable or readonly
  getMenuItemAccess() {
    this.applicationService
      .getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers.find(
          (accessSpecifier) => accessSpecifier.category === this.menuCode
        );
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  openImagePreviewDialog() {
    this.imagePreviewDialogService.open({ "images": this.allLegalDocFilesInFolder })
  }

  openLegalReportPreviewDialog() {
    this.imagePreviewDialogService.open({ "images": this.allLegalReportFilesInFolder })
  }

  openImageFileUploadDialogForLegalReport() {
    if (this.selectedLegalDocument.legalReportFolderUid) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.selectedLegalDocument.legalReportFolderUid, "applicationUid": this.application.uid, "files": this.allLegalReportFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getLegalReportFolderFiles(data.folderUid)
      })
    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  openImageFileUploadDialogForDocuments() {
    if (this.selectedLegalDocument.folderUid) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.selectedLegalDocument.folderUid, "applicationUid": this.application.uid, "files": this.allLegalDocFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getLoanDocumentFolderFiles(data.folderUid)
      })
    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  openfileDeleteConfirmation(selectedFile) {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this File?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteFile(selectedFile)
      }
    })
  }

  openDeleteConfirmation() {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this Legal Document?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteLegalDocument(this.selectedLegalDocument)
      }
    })
  }

  deleteLegalDocument(selectedLegalDocument) {
    this.applicationService.deleteLegalDocument(this.application.uid, selectedLegalDocument.uid).subscribe((response) => {
      this._snackbar.open("Legal document deleted successfully.", "Close", {
        duration: 4000,
      });
      // if only one record present and if we delete then selectedLegalDocument is not present 
      // so to update the UI we are resetting the selectedLegalDocument
      this.selectedLegalDocument = null;
      this.getLegalDocument();
    }, (failure) => {
      let errormesg = []
      errormesg.push("Legal document deleted failed.")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  deleteFile(selectedFile) {
    this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("File deleted successfully", "Close", {
          duration: 2000,
        });
        this.getLoanDocumentFolderFiles(this.selectedLegalDocument.folderUid);
        this.getLegalReportFolderFiles(this.selectedLegalDocument.legalReportFolderUid);
      } else {
        let errormesg = []
        errormesg.push("File deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("File deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  //this function will call onclick of download icon in file's section
  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      FileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully.", "Close", {
        duration: 5000,
      });
    })
  }

  viewPdf(file) {
    this.fileService.fileStreamById(file.fileId, "false").subscribe(res => {
      window.open(res.data, '_blank');
    })
  }

  truncate(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    const str = String(value).trim();

    return str.length > 150 ? str.slice(0, 150) + '...' : str;
  }

  copyText(text: string) {
    (navigator as any).clipboard.writeText(text);
    this._snackbar.open("Message copied to clipboard", "Close", { duration: 5000 });
  }
}
